'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dPage$0024 from "./presto.-Dashboard-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499 from "./presto.-Presto-Router$$anon$99.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$98() {
  this.bph = null;
  this.bp9 = null;
  this.bpa = false;
  this.bpi = null;
  this.bpj = false;
  this.bpm = null;
  this.bpf = null;
  this.bpg = false;
  this.bpb = null;
  this.bpc = false;
  this.bpd = null;
  this.bpe = false;
  this.bpk = false;
  this.bpl = false;
  this.bph = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpm = "DashboardPage";
}
export { $c_Lpresto_PrestoRouter$$anon$98 as $c_Lpresto_PrestoRouter$$anon$98 };
$p = $c_Lpresto_PrestoRouter$$anon$98.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$98;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$98() {
}
export { $h_Lpresto_PrestoRouter$$anon$98 as $h_Lpresto_PrestoRouter$$anon$98 };
$h_Lpresto_PrestoRouter$$anon$98.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bph;
});
$p.M = (function() {
  if ((!this.bpa)) {
    this.bp9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bpa = true;
  }
  return this.bp9;
});
$p.O = (function() {
  if ((!this.bpj)) {
    this.bpi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpj = true;
  }
  return this.bpi;
});
$p.E = (function() {
  return this.bpm;
});
$p.t = (function() {
  if ((!this.bpg)) {
    this.bpf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpg = true;
  }
  return this.bpf;
});
$p.N = (function() {
  if ((!this.bpc)) {
    this.bpb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpc = true;
  }
  return this.bpb;
});
$p.Q = (function() {
  if ((!this.bpe)) {
    this.bpd = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002499.$c_Lpresto_PrestoRouter$$anon$99();
    this.bpe = true;
  }
  return this.bpd;
});
$p.v = (function() {
  if ((!this.bpl)) {
    this.bpk = false;
    this.bpl = true;
  }
  return this.bpk;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee604) => ((p) => \u03b4scrutinee604))($j_presto$002e$002dDashboard$002dPage$0024.$m_Lpresto_DashboardPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$98 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$98, "presto.PrestoRouter$$anon$98", ({
  Ph: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$98 as $d_Lpresto_PrestoRouter$$anon$98 };
//# sourceMappingURL=presto.-Presto-Router$$anon$98.js.map
